import React from "react";
import { View, StyleSheet } from "react-native";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import BaseController from "../../common/base/BaseController";
import NtPageActionButton from "../../components/NtPageActionButton";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtSearchBar from "../../components/NtSearchBar";
import NtModal from "../../components/NtModal";
import {
  asyncStorageSetData,
  showToast,
} from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import settings from "../../config/settings";
import NtInboundRouteItem from "../components/NtInboundRouteItem";
import NtInboundRouteNewForm from "../components/NtInboundRouteNewForm";
import { fetchInboundRoutes } from "../../api/inboundroute";
import inboundroutecsvcolumndata from "../data/inboundroutecsvcolumndata";

class InboundRouteController extends BaseController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    page: 1,
  };

  column_location = "@inboundroute_column_storage";
  addModalRef = React.createRef();

  componentDidMount() {
    this.handleDefaultColumnsFetch(
      this.column_location,
      inboundroutecsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchInboundRoutes(
      this.context.user?.domain,
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
    );
    Logger("InboundRoutes fetch response", response);
    if (response.ok) {
      this.setState({
        data: response.data?.data || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchInboundRoutes(
      this.context.user?.domain,
      1, 100000,
      this.state.searchText,
    );
    return response.ok ? response.data?.data || [] : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "dialplan_destination_actions") {
      return `"${JSON.stringify(item[column]).replace(/['"]+/g, "")}"`;
    }
    if (column === "dialplan_number") return `"${item[column]}"`;
    return item[column];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  renderAddNewForm = () => (
    <NtModal ref={this.addModalRef}>
      <NtInboundRouteNewForm
        onCancel={() => this.addModalRef.current?.dismiss()}
        onCreate={() => {
          this.setState({ page: 1 }, () => this.handleDataFetch());
          this.addModalRef.current?.dismiss();
          showToast("Success", "Successfully created the new inbound route");
        }}
      />
    </NtModal>
  );

  renderRow = (item, index) => (
    <NtInboundRouteItem
      key={index}
      item={item}
      columns={this.state.columns}
      onUpdate={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully updated Inbound Route");
      }}
      onDelete={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully deleted Inbound Route");
      }}
    />
  );

  render() {
    const canEdit = this.handlePermissionCheck(settings.permissionTypeEdit);
    const count = this.state.totalItems || 0;
    const subtitle = `Map external DIDs to internal destinations · ${count} route${count === 1 ? "" : "s"}`;

    const actions = canEdit ? (
      <NtPageActionButton
        icon="plus"
        title="Add Inbound Route"
        variant="primary"
        onPress={() => this.addModalRef.current?.show()}
      />
    ) : null;

    const searchBar = (
      <NtSearchBar
        value={this.state.searchText}
        onChangeText={this.handleSearch}
      />
    );

    return (
      <NtRootPageContainer
        pageTitle="Inbound Routes"
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
        actions={actions}
      >
        <NtPageSection
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              headerContainerStyle={{ marginRight: canEdit ? 35 : 0 }}
              columns={inboundroutecsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="inboundroutes"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>

        {this.renderAddNewForm()}
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default InboundRouteController;
